var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bgw",staticStyle:{"padding":"0 15px"}},[_c('p',{staticStyle:{"font-size":"1.5rem","font-family":"PingFangSC-Medium, sans-serif","padding":"1rem 0"}},[_vm._v(_vm._s(_vm.helpDetail.title))]),_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.helpDetail.body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }